import { createFileRoute } from '@tanstack/react-router'
import { ConversationWorkspace } from '../features/conversation'

function Conversation() {
  const { workspaceId, conversationId } = Route.useParams()
  return <ConversationWorkspace workspaceId={workspaceId} conversationId={conversationId} />
}

export const Route = createFileRoute('/w/$workspaceId/conversations/$conversationId')({
  component: Conversation,
})
